import { ReportRunner } from "@/features/reports/ReportRunner";

export function ReportsPage() {
  return <ReportRunner />;
}
